import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import { GenBirimService } from '../ctl-gen-birim.service';
@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private service: GenBirimService) {}

    getData(control: any) {
        let tableName = "";
        tableName = control.dlistMetadata.baseEntity;
        if(this.service.isYetki) tableName = tableName + "?YetkiTuru=Y"
        const dataSource = this.dataCoreService.getOData(tableName);
        dataSource.select([]);
        const filterArr = [];
        if(this.service.birimTuru) filterArr.push(['BirimTuru', '=', this.service.birimTuru]);
        filterArr.push(['AktifEh', '=', 'E']);
        if(filterArr.length > 0) dataSource.filter(filterArr)
        dataSource.sort([{ selector: 'Kod', desc: true }]);
        return dataSource;
    }

    getCheckData(code: number) {
        const dataSource = this.dataCoreService.getOData('IkaBirimKatsayi');
        dataSource.select(['Kod']);
        const filterArr = [];
        filterArr.push(['Kod', '=', code]);
        if (filterArr.length > 0) dataSource.filter(filterArr);
        return dataSource;
}

}
